import type { ObjectWithDefault } from '../../theme-provider/types'
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types'

export function safeColor(color: string | ObjectWithDefault<string>): string {
  if (typeof color === 'string') return color
  if (typeof color === 'object' && THEME_UI_DEFAULT_KEY in color)
    return color[THEME_UI_DEFAULT_KEY] as string
  return '#fff'
}
